export default __webpack_public_path__ + "7c76674c7eeffe6a82f3cca710075858.woff2";